import React from 'react'
import { Col, Row, Spinner } from 'react-bootstrap'

interface ThemeProps {
    variant?: string;
    size?: "sm" | undefined;
}
const SmashSpinner = (props?: ThemeProps) => {
    const defaults = { variant: 'primary' }

    const options = { ...defaults, ...props };

    if (options.size) {
        return (
            <Row >
                <Col className="d-flex justify-content-center">
                    <Spinner animation="border" variant={options.variant} size={options.size} role="status" />
                </Col>
            </Row>
        )
    }

    return (
        <Row >
            <Col className="d-flex justify-content-center">
                <Spinner animation="border" variant={options.variant} role="status" />
            </Col>
        </Row>
    )
}

export default SmashSpinner